<template>
  <div class="server-create-index">
    <page-header :title="headerTitle" :tabs="reportsOptions" :current-tab.sync="summaryType" @update:currentTab="handleTagChange">
      <div slot="res-status-tab" v-if="summaryType === 'reports' && options && options.length>1">
        <bill-config :billShared.sync="billShared" :projectShared.sync="projectShared" :projectSharedShow="projectSharedShow" @update:currency="currencyChange" />
      </div>
    </page-header>
    <component :is="summaryType" :billShared="billShared" :projectShared="projectShared" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { currencyUnitMap } from '@/constants/currency'
import currencyMixin from '@Bill/mixins/currency'
import shareMixin from '@Bill/mixins/share'
import BillConfig from '@Bill/sections/BillConfig'
import Subscription from './form/Subscription'
import Reports from './form/Reports'

export default {
  name: 'BillSummary',
  components: {
    Reports,
    Subscription,
    BillConfig,
  },
  mixins: [currencyMixin, shareMixin],
  data () {
    const routerQuery = this.getRouterQuery()
    return {
      headerTitle: this.$t('bill.summary'),
      summaryType: routerQuery,
      routerQuery,
      reportsOptions: [
        {
          key: 'reports',
          label: this.$t('bill.reports'),
        },
        {
          key: 'subscription',
          label: this.$t('bill.subscription'),
        },
      ],
    }
  },
  computed: {
    ...mapState('common', {
      currency: state => state.bill.currency,
      currencyOpts: state => state.bill.currencyOpts,
    }),
    options () {
      return this.currencyOpts.map(val => {
        const localItem = currencyUnitMap[val.item_id]
        const text = localItem ? localItem.label : val.item_name
        return {
          ...val,
          item_name: this.$t('bill.text_39', [text]),
        }
      })
    },
  },
  created () {
    // this.checkRouteQuery(this.routerQuery)
  },
  mounted () {
    this.detectBack() // 在用户点击 back 的时候，表单的处理方案
    this.$bus.$on('summaryTypeChange', (type) => {
      this.summaryType = type
    })
  },
  beforeDestroy () {
    window.removeEventListener('popstate', this.popstate)
  },
  methods: {
    handleTagChange (val) {
      // this.checkRouteQuery(val)
    },
    detectBack () {
      window.addEventListener('popstate', this.popstate, false)
    },
    popstate (e) {
      if (e.state) {
        // 侦测是用户触发的后退操作, dosomething
        // 这里刷新当前 url
        window.location.reload()
      }
    },
    getRouterQuery () {
      let routerQuery = this.$route.query.type
      if (!['reports', 'subscription'].find(val => val === routerQuery)) {
        routerQuery = 'reports'
      }
      return routerQuery
    },
  },
}
</script>
